import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Construction from "./sections/Construction";
import Trayectoria from "./sections/Trayectoria";
import Services from "./sections/Services";
import Impacto from "./sections/Impacto";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Construction />
      <Trayectoria />
      <Services />
      <Impacto />
      <Contact />
      <Footer />
    </div>;
}